module.exports = __webpack_public_path__ + "5eb45a76a9a83b309f2df39655549251.svg";